import { Button, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import React from 'react';
var ConfirmationDialog = function (_a) {
    var isOpen = _a.isOpen, title = _a.title, content = _a.content, onClose = _a.onClose;
    function handleCancel() {
        onClose(false);
    }
    function handleOk() {
        onClose(true);
    }
    return (React.createElement(Dialog, { open: isOpen },
        title && React.createElement(DialogTitle, null, title),
        React.createElement(DialogContent, { dividers: true }, content),
        React.createElement(DialogActions, null,
            React.createElement(Button, { color: "secondary", onClick: handleCancel }, "Cancel"),
            React.createElement(Button, { onClick: handleOk }, "Ok"))));
};
export { ConfirmationDialog };
//# sourceMappingURL=ConfirmationDialog.js.map